import _extends from "@babel/runtime/helpers/extends";
import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["after", "type"];
import * as React from 'react';
import { Input } from '../../text-input';
import { IconEye, IconEyeOff } from '../../../../icons';
import { Tooltip } from '../../../tooltip';
import { ControlShapeType } from '../../../../library';
export var PasswordInput = React.forwardRef(function (props, ref) {
  var _React$useState = React.useState(false),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    showPassword = _React$useState2[0],
    setShowPassword = _React$useState2[1];
  var handleShowToggle = function handleShowToggle(e) {
    e.preventDefault();
    setShowPassword(!showPassword);
  };
  var renderToggle = function renderToggle() {
    if (props.isDisabled || props.disabled) return null;
    return React.createElement(Tooltip, {
      hoverOpenDelay: 850,
      content: showPassword ? 'Hide Password' : 'Show Password'
    }, React.createElement(Input.Button, {
      appearance: "minimal",
      onClick: handleShowToggle
    }, showPassword ? React.createElement(IconEyeOff, null) : React.createElement(IconEye, null)));
  };
  var after = props.after,
    type = props.type,
    inputProps = _objectWithoutProperties(props, _excluded);
  return React.createElement(Input, _extends({
    ref: ref,
    className: 'input-password',
    type: showPassword && !props.isDisabled ? 'text' : 'password'
  }, inputProps, {
    after: Array.isArray(props.after) ? [].concat(_toConsumableArray(props.after), [renderToggle()]) : !!props.after ? [props.after, renderToggle()] : renderToggle()
  }));
});
PasswordInput.defaultProps = {
  shape: ControlShapeType.ROUNDED
};
PasswordInput.displayName = 'PasswordInput';